// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"8604fac4","3013":"7d04a65c"}[chunkId] + ".chunk.css";
};